// InteliChat global search (Cmd/Ctrl+K) - shared open/close state.
// Module-level so the topbar button and the shell-mounted overlay talk
// to the same instance without prop drilling or a store namespace.
import { ref } from 'vue';

const isOpen = ref(false);

export function useInteliSearch() {
  const open = () => {
    isOpen.value = true;
  };
  const close = () => {
    isOpen.value = false;
  };
  const toggle = () => {
    isOpen.value = !isOpen.value;
  };
  return { isOpen, open, close, toggle };
}
